function initIngredientModal() {

    const modal = document.getElementById('ingredients-modal');

    if (!modal) return;

    if (modal.dataset.initialized === 'true') return;
    modal.dataset.initialized = 'true';

    const openButtons = document.querySelectorAll('.js-view-all-ingredients');
    const closeButton = modal.querySelector('.js-close-ingredients-modal');
    const overlay = modal.querySelector('.ingredients_modal_overlay');
    const modalBody = modal.querySelector('.ingredients_modal_body');
    const showMoreButton = modal.querySelector('.js-ingredients-show-more');

    function collapseIngredientList() {
        modalBody?.classList.remove('is-expanded');
    }

    function openModal() {
        collapseIngredientList();
        modal.classList.add('is-open');
        document.body.classList.add('ingredients-modal-open');
    }

    function closeModal() {
        modal.classList.remove('is-open');

        setTimeout(() => {
            if (!modal.classList.contains('is-open')) {
                document.body.classList.remove('ingredients-modal-open');
                collapseIngredientList();
            }
        }, 500);
    }

    if (showMoreButton && modalBody) {
        showMoreButton.addEventListener('click', () => {
            modalBody.classList.add('is-expanded');
        });
    }

    openButtons.forEach(button => {
        button.addEventListener('click', openModal);
    });

    if (closeButton) {
        closeButton.addEventListener('click', closeModal);
    }

    if (overlay) {
        overlay.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function(event){

        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }

    });

}

document.addEventListener('DOMContentLoaded', initIngredientModal);

document.addEventListener('shopify:section:load', initIngredientModal);
